/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Shoutbox = {
    toggle: function() {
        var shoutbox = $(".shoutbox");

        if (shoutbox.data('status') == 'closed') {
            shoutbox.addClass('open').data('status', 'open');
            Cookies.set('shoutbox_status', 'open');

            Shoutbox.updater();
        } else if (shoutbox.data('status') == 'open') {
            shoutbox.removeClass('open').data('status', 'closed');
            Cookies.set('shoutbox_status', 'closed');

            clearTimeout(Shoutbox.updaterTimeout);
        }
    },
    updaterTimeout: false,
    lastMessageId: 0,
    currentChat: 0,
    updating: false,
    updater: function() {
        if (!Shoutbox.updating) {
            Shoutbox.updating = true;

            var shoutbox = $(".shoutbox");

            $.ajax({
                url: '/a/shoutbox/updater',
                type: 'POST',
                dataType: 'json',
                data: {
                    'lastMessageId': Shoutbox.lastMessageId,
                    'currentChat': Shoutbox.currentChat
                },
            }).done(function(data) {
                /* Online users */
                $(".shoutbox-online-count").text(data.onlineUsers.length);

                var onlineHtml = '';

                for (var i = data.onlineUsers.length - 1; i >= 0; i--) {
                    var user = data.onlineUsers[i];

                    onlineHtml += '<div class="row no-gutters box-online-user">';

                    onlineHtml += '<div class="col-2">';
                    onlineHtml += '<div class="avatar" style="background-image: url(\''+user.avatar+'\');"></div>';
                    onlineHtml += '</div>';

                    onlineHtml += '<div class="col-8 align-self-center">';
                    onlineHtml += '<div class="username">'+user.username+'</div>';
                    onlineHtml += '</div>';

                    if (UserUsername != user.username) {
                        onlineHtml += '<div class="col-1">';
                        onlineHtml += '<div class="menu shoutbox-new-private-message" data-toggle="tooltip" title="Conversar com '+user.username+'" data-id="'+user.user_id+'" data-username="'+user.username+'">';
                        onlineHtml += '<i class="far fa-comment-alt"></i>';
                        onlineHtml += '</div>';
                        onlineHtml += '</div>';
                    }

                    onlineHtml += '</div>';
                }

                $(".shoutbox-online-list").html(onlineHtml);

                /* Messages */
                if (data.messages.length > 0) {
                    var messagesHtml = '';

                    for (var i = data.messages.length - 1; i >= 0; i--) {
                        var msg = data.messages[i];

                        if ($("#shoutbox-message-"+msg.id).length == 0) {
                            var date = new Date(msg.created_at.replace(' ', 'T'));
                            var time = date.getHours() + ':' + date.getMinutes();

                            messagesHtml += '<div class="row no-gutters box-message" id="shoutbox-message-'+msg.id+'">';
                            messagesHtml += '<div class="col-2">';
                            messagesHtml += '<div class="avatar" style="background-image: url(\''+msg.avatar+'\');"></div>';
                            messagesHtml += '</div>';

                            messagesHtml += '<div class="col-10 message-area">';
                            messagesHtml += '<span class="username">'+msg.username+'</span>';
                            messagesHtml += ' <span class="time">'+time+'</span>';

                            messagesHtml += '<div class="message">';
                            messagesHtml += msg.message;
                            messagesHtml += '</div>';
                            messagesHtml += '</div>';
                            messagesHtml += '</div>';

                            if (msg.id > Shoutbox.lastMessageId) {
                                Shoutbox.lastMessageId = msg.id;
                            }
                        }
                    }

                    $(".shoutbox-messages-area").append(messagesHtml);
                    $(".shoutbox-messages-area").slimScroll({
                        scrollTo: $(".shoutbox-messages-area")[0].scrollHeight
                    });
                }

                /* Private messages session */
                var totalNtf = 0;

                if (data.privateMessagesSessions.length > 0) {
                    var privateMessagesSessionsHtml = '';

                    for (var i = data.privateMessagesSessions.length - 1; i >= 0; i--) {
                        var user = data.privateMessagesSessions[i];

                        privateMessagesSessionsHtml += '<div class="row no-gutters justify-content-center box-user shoutbox-new-private-message" data-id="' + user.id +'" data-username="'+user.username+'">';
                        privateMessagesSessionsHtml += '<div class="col-4">';
                        privateMessagesSessionsHtml += '<div class="avatar" style="background-image: url(\'' + user.avatar + '\');">';

                        if (user.ntf > 0) {
                            privateMessagesSessionsHtml += '<div class="ntf">'+user.ntf+'</div>';
                            totalNtf = totalNtf + user.ntf;
                        }

                        privateMessagesSessionsHtml += '</div>';
                        privateMessagesSessionsHtml += '<div class="username">'+user.username+'</div>';
                        privateMessagesSessionsHtml += '</div>';
                        privateMessagesSessionsHtml += '</div>';
                    }

                    $(".shoutbox-private-sessions-area").html(privateMessagesSessionsHtml);
                }

                if (totalNtf > 0) {
                    $(".shoutbox-general-ntf").fadeIn().text(totalNtf);
                } else {
                    $(".shoutbox-general-ntf").fadeOut().text('');
                }

                if (shoutbox.data('status') == 'open') {
                    timer = 2000;
                } else {
                    timer = 8000;
                }

                Shoutbox.updating = false;

                Shoutbox.updaterTimeout = setTimeout(function() {
                    Shoutbox.updater();
                }, timer);
            });
}
},
sendMessage: function(e) {
    e.preventDefault();

    var form = $(this);

    if (form.hasClass('disabled')) {
        return false;
    }

    var text = form.find('input[name="message"]').val();

    if (text == '') {
        form.effect('shake', { distance: 3 });
    } else {
        form.addClass('disabled').animate({'opacity': 0.5});

        $.ajax({
            url: '/a/shoutbox/sendMessage',
            type: 'POST',
            dataType: 'json',
            data: {'message': text, 'currentChat': Shoutbox.currentChat},
        }).done(function(data) {
            form.removeClass('disabled').animate({'opacity': 1});

            if (data.status == 'error') {
                var message = "";

                for (i = data.messages.length - 1; i >= 0; i--) {
                    message += data.messages[i];

                    if (i > 0) {
                        message += '<br>';
                    }
                }

                Alertbox({
                    title: "Erro ao enviar mensagem",
                    content: message,
                    type: 'error'
                });
            } else {
                form.find('input[name="message"]').val('').focus();
            }
        });
    }
},
newPrivateMessage: function() {
    clearTimeout(Shoutbox.updaterTimeout);

    var id       = $(this).data('id');
    var username = $(this).data('username');

    var shoutbox = $(".shoutbox");

    if (shoutbox.data('status') == 'closed') {
        Shoutbox.toggle();
    }

    Shoutbox.lastMessageId = 0;
    Shoutbox.currentChat = id;

    $(".shoutbox-title-messages").text(username);
    $(".shoutbox-messages-area").html('');
    $(".shoutbox-send-message-form .input").val('');

    $(".shoutbox-back-to-general").fadeIn();

    Shoutbox.updater();
},
backToGeneral: function() {
    clearTimeout(Shoutbox.updaterTimeout);

    Shoutbox.lastMessageId = 0;
    Shoutbox.currentChat = 0;

    $(".shoutbox-back-to-general").fadeOut();

    $(".shoutbox-title-messages").text('Mensagens');
    $(".shoutbox-messages-area").html('');
    $(".shoutbox-send-message-form .input").val('');

    Shoutbox.updater();
},
init: function() {
    Shoutbox.updater();

    $(".shoutbox-toggle").on('click', Shoutbox.toggle);

    $(".shoutbox .online-list").slimScroll({
        height: '300px'
    });

    $(".shoutbox .messages-area").slimScroll({
        start: 'bottom',
        height: '260px'
    });

    $(".shoutbox .private-messages-area").slimScroll({
        height: '300px'
    });

    $(document).on('click', ".shoutbox-new-private-message", Shoutbox.newPrivateMessage);

    $(".shoutbox-send-message-form").on('submit', Shoutbox.sendMessage);
    $(".shoutbox-back-to-general").on('click', Shoutbox.backToGeneral);
}
};

$(document).ready(function() {
    if (UserLogged) {
        Shoutbox.init();
    }
});
